import CommunicationToolsPage from "../../components/communication-tools";

const bulkSmsPageProps = {
  heroTitle: "Deliver Text\nMessages Effortlessly",
  heroDescription:
    "Reach thousands of customers instantly with our reliable Bulk SMS service. Send promotional offers, important updates, and reminders with just a few clicks. Our platform ensures high delivery rates and provides detailed reports to track your campaign's performance.",
  heroImage:
    "https://res.cloudinary.com/dbpb7sjus/image/upload/v1744330116/sleenshort/bulk-sms/z9zsmir0mvmrqjsqtvgg.png",

  whyChooseTitle: "Why Choose SleengShort messaging service",
  features: [
    {
      icon: "https://res.cloudinary.com/dbpb7sjus/image/upload/v1744330097/sleenshort/bulk-sms/pr8xb1a4bs9zyfizymbq.png",
      title: "Global Reach",
      descr: "Send messages to any mobile device, anywhere in the world",
    },
    {
      icon: "https://res.cloudinary.com/dbpb7sjus/image/upload/v1744330097/sleenshort/bulk-sms/uqevhaw6wgp4mwepvowy.png",
      title: "Personalization",
      descr:
        "Use merge tags to address recipients by name and tailor your message.",
    },
    {
      icon: "https://res.cloudinary.com/dbpb7sjus/image/upload/v1744330098/sleenshort/bulk-sms/o0is7ohzovfr0wwglhbn.png",
      title: "Scheduling",
      descr: "Plan your messages in advance for optimal timing.",
    },
    {
      icon: "https://res.cloudinary.com/dbpb7sjus/image/upload/v1744330098/sleenshort/bulk-sms/znsotwbw2qecsqarlxor.png",
      title: "Real-Time Reports",
      descr: "Track delivery rates, opens, and responses in real time.",
    },
    {
      icon: "https://res.cloudinary.com/dbpb7sjus/image/upload/v1744330096/sleenshort/bulk-sms/nu3u3kqox1eta5eewpve.png",
      title: "Affordable Pricing",
      descr: "Flexible plans to suit businesses of all sizes.",
    },
  ],

  useCaseTitle: "Use Case",
  useCases: [
    {
      img: "https://res.cloudinary.com/dbpb7sjus/image/upload/v1744330101/sleenshort/bulk-sms/jdk7qyutgvsuwiug4alf.png",
      title: "Marketing:",
      descr: "Promote sales, events, and new products",
    },
    {
      img: "https://res.cloudinary.com/dbpb7sjus/image/upload/v1744330100/sleenshort/bulk-sms/vfemcodypavrngw6g3wo.png",
      title: "Alerts:",
      descr:
        "Send appointment reminders, delivery notifications, and emergency alerts.",
    },
    {
      img: "https://res.cloudinary.com/dbpb7sjus/image/upload/v1744330102/sleenshort/bulk-sms/ufqgdem6yrsndrg2zsbx.png",
      title: "Customer Engagement:",
      descr: "Share loyalty rewards, surveys, and updates.",
    },
  ],
};

export default function BulkSmsPage() {
  return <CommunicationToolsPage {...bulkSmsPageProps} />;
}
